import { Injectable, inject } from '@angular/core';
import { FilesService } from '@app/pages/cmms/services/files.service';
import { TableType } from '@app/pages/cmms/types';
import { ActionTypes, IActionCenterUnlinker } from '../../interfaces';
import { FileClassificationSuggestionsUnlinker } from './files-unlinker';

@Injectable({
	providedIn: 'root',
})
export class ActionCenterUnlinkerFactory {
	unlinkerMap;
	filesService = inject(FilesService);

	deps = {
		[TableType.FILES]: {
			filesService: this.filesService,
		},
	};

	constructor() {
		this.unlinkerMap = {
			[TableType.FILES]: {
				classificationSuggestions: FileClassificationSuggestionsUnlinker,
			},
		};
	}

	createUnlinker(
		tableType: TableType,
		targetType: ActionTypes
	): IActionCenterUnlinker<any> {
		const deps = this.deps[tableType];
		return new this.unlinkerMap[tableType][targetType](deps);
	}
}
